document.addEventListener("DOMContentLoaded", function () {

  function to350(url) {
    if (!url) return '';
    return url
      .replace(/_(\d+x\d+|\d+x)(?=\.)/i, '')
      .replace(/(\.(jpg|jpeg|png|webp))(.*)?$/i, '_350x$1$3');
  }

  const interval = setInterval(function () {

    if (typeof _usfGetImgAttrs !== "function") return;

    clearInterval(interval);

    const original = _usfGetImgAttrs;

    window._usfGetImgAttrs = function (img, imgUrl, scaledImageUrl) {

      const pathname = window.location.pathname;

      const baguesFemmePaths = [
        '/collections/bagues-femme',
        '/es/collections/anillos-mujer',
        '/it/collections/anelli-donna',
        '/de/collections/ringe-dame',
        '/pl/collections/bagues-femme',
        '/en/collections/bagues-femme',
        '/collections/saint-valentin',
        '/es/collections/saint-valentin',
        '/it/collections/saint-valentin',
        '/de/collections/saint-valentin',
        '/pl/collections/saint-valentin',
        '/en/collections/saint-valentin'
      ];

      const isTarget = baguesFemmePaths.some(function (path) {
        return pathname.indexOf(path) === 0;
      });

      if (!isTarget) {
        return original(img, imgUrl, scaledImageUrl);
      }

      const small = to350(scaledImageUrl || imgUrl);

      return {
        src: small,
        srcset: small + " 350w",
        sizes: "350px",
        alt: img?.alt || '',
        size: 350,
        width: 350,
        height: 350,
        loading: "eager",
        fetchpriority: "high",
        class: "motion-reduce"
      };

    };

  }, 50);

  function fixHoverImages() {

    document.querySelectorAll(".card-media").forEach(function(card){

      const imgs = card.querySelectorAll("img");
      if (imgs.length === 0) return;

      imgs.forEach(function(img, index){

        if (index === 0) {
          img.loading = "eager";
          img.fetchPriority = "high";
        } else {
          img.loading = "lazy";
          img.fetchPriority = "auto";
        }

      });

    });

  }

  setTimeout(fixHoverImages, 500);

  const observer = new MutationObserver(function () {
    requestAnimationFrame(fixHoverImages);
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

});